import { Controller, useFormContext, useFormState } from 'react-hook-form';

import { Input as AntdInput, type InputProps } from 'antd';

import { ErrorMessage } from './ErrorMessage';
import { InputLabel } from '../ui/InputLabel';

interface IProps extends InputProps {
  id: string;
  name: string;
  type?: 'text' | 'number';
  label?: string;
  hideError?: boolean;
  maxLength?: number;
}

export const Input = ({ id, name, maxLength, type = 'text', hideError = false, label, ...props }: IProps) => {
  const { control } = useFormContext();
  const { errors } = useFormState({ control });

  const message = errors[name]?.message as string | undefined;

  return (
    <div>
      <InputLabel>{label}</InputLabel>
      <Controller
        control={control}
        name={name}
        rules={{ required: true }}
        render={({ field: { onChange, ...restField } }) => (
          <AntdInput
            id={id}
            status={message ? 'error' : ''}
            maxLength={maxLength}
            {...restField}
            {...props}
            onChange={event => {
              return type === 'number' ? onChange(Number(event.target.value)) : onChange(event.target.value);
            }}
          />
        )}
      />
      <ErrorMessage hide={hideError} fieldName={name} />
    </div>
  );
};
